import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  Avatar,
  Chip,
  Tooltip,
  CircularProgress
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  ButtonGroup,Popover
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  Assignment,
  Group,
  Close,
  ArrowForwardIos,
  CheckCircle,
  Block,
  Receipt,
  AcUnit,
  DateRange,
  HourglassEmpty,
  ErrorOutline
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";
import { DatePicker } from "@material-ui/pickers";

import { makeStyles } from "@material-ui/styles";

import MUIDataTable from "mui-datatables";

import { Skeleton } from "@material-ui/lab";

import { useSnackbar } from "notistack";
import Format from "date-fns/format";

import {
  FinanceService,
  AdminService,
  Validator,
} from "../../../../../../utils/web_config";
import { useTransactionTypes } from "../../../../hooks/use_hooks";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    marginRight:10
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function PaymentRequests(props) {
  const classes = useStyles();
  const history = useHistory();

  const transactionTypes = useTransactionTypes();

  const [accountData, setAccountData] = useState({});
  const [transactions, setTransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    status: "Loading payment requests....",
    loading: false,
    toggling: false,
    data: [],
  });

  const [from, setFrom] = useState({
    value: new Date(),
    error: "",
  });
  const [to, setTo] = useState({
    value: new Date(),
    error: "",
  });

  const [range, setRange] = useState({ index: 0, acnhor: null });

  const [transactionId,setTransactionId] = useState({
    value:"",
    error:""
  });


  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [refundOpen, setrefundOpen] = useState(false);

  const [refundTransactionId,setRefundTransactionId]=useState("");


  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getTransactions(accountData.token,from.value, to.value);
  }, []);



  //////////////

  const onFromChange = (date) => {
    setFrom({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(accountData.token, date, to.value,transactionId.value);
  };
  const onToChange = (date) => {
    setTo({ value: date, error: "" });
    setRange({ ...range, index: null });
    getTransactions(accountData.token, from.value, date,transactionId.value);
  };

  //////////
  const transactionsColums = [
    {
      name: "payment_method",
      label: "Payment Method",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "service_name",
      label: "Service Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "transaction_id",
      label: "Transaction Id",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "consumer_msisdn",
      label: "Customer MSIDN",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "service_status",
      label: "Service Status",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {transactions.data[dataI].status=="PAID"&&<CheckCircle fontSize="small" />}
                  {transactions.data[dataI].status=="PENDING"&&<HourglassEmpty fontSize="small"/>}
                  {transactions.data[dataI].status=="FAILED"&&<Block fontSize="small" />}
                </Avatar>
              }
              variant="outlined"
              color={
                transactions.data[dataI].status == "PAID"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(transactions.data[dataI].status)}
            />
          );
        },
      },
    },
  ];

  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search payment request...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    customToolbarSelect:(selectedRows, displayData, setSelectedRows) => (
      <Box>
        <Button variant="outlined" onClick={()=>{
          setRefundTransactionId(displayData[selectedRows.data[0]['index']]['data'][2]);
          setrefundOpen(true);
          console.log("transaction Id",displayData[selectedRows.data[0]['index']]['data'][2]);
        }} size="small" color="primary"><Typography>Refund</Typography></Button>
      </Box>
    ),
   
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
  };

  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  ///////////////////////////////////

  ///////////////////////////////////

  const getTransactions = (token,fromDate,toDate,tId="") => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setTransactions({ ...transactions, loading: true });

    let url = new FinanceService().GET_ALL_PAYMENT_REQUESTS + "?per_page=1000&start_date="+Format(fromDate, ["yyyy-MM-dd"])+"&end_date="+Format(toDate, ["yyyy-MM-dd"]);

    if(tId!= ""){
      url =  new FinanceService().GET_ALL_PAYMENT_REQUESTS + "?per_page=1000&start_date="+Format(fromDate, ["yyyy-MM-dd"])+"&end_date="+Format(toDate, ["yyyy-MM-dd"])+"&transaction_id="+tId;
    }

    usersInstance
      .get(url)
      .then(function (response) {
        setTransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setTransactions({
            ...transactions,
            status: "There are no transactions available",
          });
        } else {
          var groups = new Validator().groupArrayOfObjects(
            d.data,
            "service_name"
          );
          var keys = Object.keys(groups);
          setTransactions({
            ...transactions,
            data: d.data,
            allData: d.data,
            keys: keys,
            groups: groups,
          });
        }
      })
      .catch(function (error) {
        setTransactions({ ...transactions, loading: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setTransactions({ ...transactions, status: e });

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////

  const [refundLoading,setRefundLoading]= useState(false);

  const refundPayment=()=>{
    setRefundLoading(true);
    const refundInstance = axios.create(new AdminService().getHeaders(accountData.token));
    var data={
      transaction_id:refundTransactionId
    };

    refundInstance
      .post(new FinanceService().PAYMENT_REFUND,data)
      .then(function (response) {
        setRefundLoading(false);
        setrefundOpen(false);
        notify("success", "Refunded Successfully!");
      })
      .catch(function (error) {
        setRefundLoading(false);

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  }

  return (
    
    <div className={classes.root}>
      {/* Dialogs ends here */}
      <Dialog
        open={refundOpen}
        onClose={() => setrefundOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Refund Customer"}</DialogTitle>
        <DialogContent>
          <Box>
          <Grid container>
            <Grid item xs={1} md={1}>
              <ErrorOutline fontSize="large" color="secondary"/>
            </Grid>
            <Grid item xs={11} md={11}>
              <Typography>Are you sure , you want to refund this amount to this customer?</Typography>
            </Grid>
          </Grid>
    
         </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setrefundOpen(false)} color="secondary">
            Close
          </Button>
          <Button disabled={refundLoading} variant="contained" size="small" disableElevation onClick={()=>{
            refundPayment();
          }} color="color"> {refundLoading?<CircularProgress size={25} color="primary"/>:"Refund"}</Button>
        </DialogActions>
      </Dialog>




      <Popover
        id={"pop-id"}
        open={range.acnhor != null}
        anchorEl={range.acnhor}
        onClose={() => setRange({ ...range, acnhor: null })}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        elevation={4}
      >
        <Box p={2}>
          <Typography color="textSecondary">Select date range</Typography>
          <Box mt={2} mb={2}>
            <Box>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                maxDate={to.value}
                autoOk
                label={<Translate id="reports.forms.labels.from" />}
                value={from.value}
                inputVariant="outlined"
                onChange={onFromChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
            <Box>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                maxDate={new Date()}
                minDate={from.value}
                autoOk
                label={<Translate id="reports.forms.labels.to" />}
                value={to.value}
                inputVariant="outlined"
                onChange={onToChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
            <Box>
              <TextField variant="outlined" size="small" label="Transaction ID" value={transactionId.value} onChange={(e)=>{
                setTransactionId({ value:e.target.value,error:""});
                getTransactions(accountData.token, from.value, to.value,e.target.value);
              }} fullWidth />
            </Box>
          </Box>
        </Box>
      </Popover>

      {/* ////////////////////////////// */}
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h6">
            <b>Transactions</b>
          </Typography>
        </Box>

        
        <Box display="flex" mr={2} alignItems="center">
          <Box mr={2}>
            <ButtonGroup color="primary" disableElevation>
              <Button
                className={classes.btn}
                variant={range.index == 0 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 0 });
                  var date1 = new Date();
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Today
              </Button>
              <Button
                className={classes.btn}
                variant={range.index == 1 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 1 });
                  var date1 = new Date();
                  date1.setDate(date1.getDate() - 7);
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Last week
              </Button>
              <Button
                className={classes.btn}
                variant={range.index == 2 ? "contained" : "outlined"}
                onClick={() => {
                  setRange({ index: 2 });
                  var date1 = new Date();
                  date1.setDate(date1.getDate() - 30);
                  var date2 = new Date();

                  setFrom({ value: date1 });
                  setTo({ value: date2 });
                  getTransactions(accountData.token, date1, date2);
                }}
              >
                Last month
              </Button>
            </ButtonGroup>
          </Box>

          <IconButton
            color="primary"
            onClick={(e) => setRange({ ...range, acnhor: e.currentTarget })}
          >
            <DateRange />
          </IconButton>
        </Box>
      </Box>
      <Box mt={2} />
      <Grid container spacing={2}>
        {transactions?.keys?.map((tr, i) => (
          <Grid item xs={12} md={4} lg={3}>
            <Paper elevation={0} className={classes.paper}>
              <Box width={1}>
                <Box display="flex" width={1}>
                  <Box flexGrow={1}>
                    <Typography className={classes.btn} color="textSecondary">
                      {tr.toLowerCase()}
                    </Typography>
                
                  </Box>
                  {new Validator().getTransactionIcon(tr)}
                </Box>
                <Box
                  mt={1}
                  mb="4px"
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  width={1}
                >
                  <Tooltip
                    title={transactions?.groups[tr].length}
                    arrow
                    placement="top"
                  >
                    <Typography variant="h5">
                      {new Validator().formatNumber(
                        transactions?.groups[tr].length
                      )}
                    </Typography>
                  </Tooltip>

                  <Typography color="primary" align="right">
                    {new Validator().formatMoney(
                      new Validator().sum(transactions?.groups[tr], "amount")
                    )}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Box mt={2} />
      {transactions.loading && <LinearProgress />}
      <MUIDataTable
         title={
          "From " +
          Format(from.value, ["MMMM dd"]) +
          " to " +
          Format(to.value, ["MMMM dd"])
        }
        data={transactions.data}
        columns={transactionsColums}
        options={transactionsOptions}
      />
    </div>
  );
}

const PaymentRequestTransactions = withLocalize(PaymentRequests);
export { PaymentRequestTransactions };
